import { render, staticRenderFns } from "./BranchManagerModal.vue?vue&type=template&id=5d020845&scoped=true"
import script from "./BranchManagerModal.vue?vue&type=script&lang=js"
export * from "./BranchManagerModal.vue?vue&type=script&lang=js"
import style0 from "./BranchManagerModal.vue?vue&type=style&index=0&id=5d020845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d020845",
  null
  
)

export default component.exports